/*
| Developed by Dirupt
| Filename : commonSlice.ts
| Author : Philippe DESPLATS (philippe@dirupt.com)
*/

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PaletteMode } from '@mui/material'
import { RootState } from '@/stores/store'
import { CookiesService } from '@/services/cookies/cookies.service'

/*
|--------------------------------------------------------------------------
| CONTRACTS
|--------------------------------------------------------------------------
*/
export interface CommonAppBarBreadcrumbs {
	name: string
	href?: string
	alt?: string
}
export interface CommonState {
	themes: {
		mode: PaletteMode
	}
	language: string
}

/*
|--------------------------------------------------------------------------
| INIT STATE
|--------------------------------------------------------------------------
*/
const initialState: CommonState = {
	themes: {
		mode: 'dark',
	},
	language: 'fr',
}

/*
|--------------------------------------------------------------------------
| SLICE
|--------------------------------------------------------------------------
*/
export const commonSlice = createSlice({
	name: 'common',
	initialState,
	reducers: {
		setThemeMode: (state, action: PayloadAction<PaletteMode>) => {
			state.themes.mode = action.payload
			CookiesService.setCookie('senskle-color-mode', action.payload)
		},
		setLanguage: (state, action: PayloadAction<string>) => {
			state.language = action.payload
			CookiesService.setCookie('NEXT_LOCALE', action.payload)
		},
	},
})

/*
|--------------------------------------------------------------------------
| EXPORT SELECTORS
|--------------------------------------------------------------------------
*/
export const selectThemeMode = (state: RootState) => state.common.themes.mode
export const selectLanguage = (state: RootState) => state.common.language

/*
|--------------------------------------------------------------------------
| EXPORT
|--------------------------------------------------------------------------
*/
export const { setThemeMode, setLanguage } = commonSlice.actions
export default commonSlice.reducer
